export const SERVICES = [
  {
    id: "doorbell",
    title: "Camera Doorbell Installation",
    short: "Crystal-clear video, smart motion alerts, professional mounting & app setup.",
    starting_price: 99,
    image:
      "https://images.unsplash.com/photo-1659543038862-6fc68c3be84a?auto=format&fit=crop&w=1600&q=85",
    features: ["Wired or battery-powered", "Live HD app alerts", "Same-day setup"],
  },
  {
    id: "smart_lock",
    title: "Smart Door Lock Installation",
    short: "Keyless entry, encrypted access codes, full integration with your smart home.",
    starting_price: 99,
    image:
      "https://images.pexels.com/photos/7522609/pexels-photo-7522609.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Works with iOS / Android", "Auto-lock configured", "Custom user codes"],
  },
  {
    id: "security_camera",
    title: "Security Camera Systems",
    short: "Multi-camera coverage, 4K clarity, cloud or local storage configured for you.",
    starting_price: 129,
    image:
      "https://images.pexels.com/photos/26597080/pexels-photo-26597080.jpeg?auto=compress&cs=tinysrgb&w=1600&q=85",
    features: ["4K weatherproof units", "Discreet cabling", "Mobile + desktop view"],
  },
  {
    id: "alarm_system",
    title: "Alarm System Installation",
    short: "Whole-home protection with sensors, sirens, and 24/7 monitoring options.",
    starting_price: 159,
    image: "/images/alarm-system.jpg",
    features: ["Door/window sensors", "Glass-break detection", "Optional monitoring"],
  },
  {
    id: "smart_thermostat",
    title: "Smart Thermostat Installation",
    short: "Lower energy bills with intelligent climate control, calibrated and connected.",
    starting_price: 110,
    image:
      "https://images.unsplash.com/photo-1774876549476-254b00a5d648?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxzbWFydCUyMHRoZXJtb3N0YXQlMjB3YWxsfGVufDB8fHx8MTc3NzE3MTc5MXww&ixlib=rb-4.1.0&q=85",
    features: ["Nest / Ecobee certified", "C-wire installs", "Schedule programming"],
  },
  {
    id: "ceiling_fan",
    title: "Ceiling Fan Installation",
    short: "Wired safely, balanced precisely. Standard, smart, or designer fans welcome.",
    starting_price: 125,
    image: "/images/ceiling-fan.jpg",
    features: ["Up to 14ft ceilings", "Blade balancing", "Old fixture haul-away"],
  },
  {
    id: "home_media",
    title: "Home Media Setup",
    short: "TV mounting, cable concealment, surround sound — your living room, perfected.",
    starting_price: 119,
    image:
      "https://images.unsplash.com/photo-1691290692144-c456d4c2751c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxob21lJTIwdGhlYXRlciUyMHR2JTIwbW91bnRpbmd8ZW58MHx8fHwxNzc3MTcxNzg1fDA&ixlib=rb-4.1.0&q=85",
    features: ["Up to 85\" TVs", "In-wall cable hiding", "Soundbar / 5.1 tuning"],
  },
];

export const TIME_SLOTS = [
  "8:00 AM",
  "9:30 AM",
  "11:00 AM",
  "12:30 PM",
  "2:00 PM",
  "3:30 PM",
  "5:00 PM",
];

export const TESTIMONIALS = [
  {
    name: "Marcus T.",
    location: "Buckhead, Atlanta",
    quote:
      "From doorbell to surround sound — they handled every install in one visit. Cleanest cable work I've ever seen.",
    rating: 5,
    service: "Home Media + Doorbell",
  },
  {
    name: "Priya S.",
    location: "Decatur, GA",
    quote:
      "Booked Sunday, installed Monday morning. The thermostat actually saves me money now. Highly professional.",
    rating: 5,
    service: "Smart Thermostat",
  },
  {
    name: "Jordan K.",
    location: "Marietta, GA",
    quote:
      "Five cameras, one alarm panel, zero exposed wires. They walked my whole family through the app. Worth every penny.",
    rating: 5,
    service: "Security Camera System",
  },
];

export const TRUST_BADGES = [
  "Licensed & Insured",
  "Background-Checked Pros",
  "5-Star Rated",
  "Same-Week Booking",
];
